import { regex } from './regex.validator';

export function password(allowEmpty = false) {
    return regex(/^(?=.*?[a-zA-Z])(?=.*?[0-9]).{8,}$/, allowEmpty);
}
